export function debounce(func, wait = 300) {

  let timeout;

  function debounced(...args) {

    const context = this;

    clearTimeout(timeout);

    timeout = setTimeout(() => func.apply(context, args), wait);

  }

  debounced.cancel = () => clearTimeout(timeout);

  return debounced;

}

